/*
 * @Author: scg
 * @Date: 2022-03-03 13:40:18
 * @LastEditTime: 2022-03-03 13:41:37
 * @LastEditors: scg
 * @Description:
 */
export default {
  /*** 测试环境的 demo 地址 */
  // baseURL: 'https://demo.smallwatcher.info/', // 请求域名
  // fileURL: 'https://demo.smallwatcher.info/' // 文件下载域名

  /*** 正式环境的 demo 地址 */
  baseURL: "https://apidemo.spylix.com/", // 请求域名
  fileURL: "https://apidemo.spylix.com/", // 文件下载域名
};



// WEBPACK FOOTER //
// ./src/config/index.js